import React from 'react';
import { BackHandler, View } from 'react-native';

const MaskedViewIOS = () => <View>{this.props.children}</View>;

export { BackHandler, MaskedViewIOS };



// WEBPACK FOOTER //
// ./node_modules/react-navigation/src/PlatformHelpers.web.js